import React, {useEffect, useRef, useState} from "react"
import getOptions from "../Scripts/getOptions"
import OptionButton from "./OptionButton"
import Loading from "./Loading"

function OptionBar(props) {

    const divRef = useRef(null)
    const [options, setOptions] = useState(null);
    const [status, setStatus] = useState("loading")
    const [lastPrompt, setLastPrompt] = useState(props.prompt)

    const getOptionsCall = async () => {
        setStatus("loading")
        const gotOptions = await getOptions(props.prompt)
        if (gotOptions) {
            setOptions(gotOptions)
            setStatus("ready")
        } else {
            setOptions(null)
            setStatus("error")
        }
    }

    useEffect(() => {
        if (props.prompt !== lastPrompt) {
            setLastPrompt(props.prompt)
            getOptionsCall()
        } else if (status === "loading" && !options) {
            getOptionsCall()
        }
    }, [props.prompt])

    useEffect(() => {
        if (props.state === "start") return
        const element = document.getElementById("optionbar")
        if (!element) return
        element.style.marginBottom = '0'
        requestAnimationFrame(() => {
            element.style.marginBottom = "4rem"
        })
    }, [props.state])

    useEffect(() => {
        if (status !== "ready" || typeof window === "undefined") return
        const element = divRef.current
        const margin = window.innerWidth <= 767 ? 16 * 6 : 0
        element.style.height = '0'
        requestAnimationFrame(() => {
            element.style.height = element.scrollHeight + margin + "px"
        })
    }, [status])

    if (status === "error") {
        return (
            <div id="optionbar">
                <p>something went wrong — please retry.</p>
                <button onClick={getOptionsCall}>retry</button>
            </div>
        )
    }

    if (status === "loading" || !options) {
        return <Loading></Loading>
    }

    return (
        <div ref={divRef} id="optionbar">
            {options?.map((option, index) => (
                <OptionButton key={index} text={option} setChoice={props.setChoice} showSteps={() => props.showSteps()}/>
            ))}
        </div>
    )
}

export default OptionBar
